import { Box } from "@mui/material";
import { ReactComponent as Export } from "assets/Export.svg";
import ThemeContext from "components/app/Context";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useState } from "react";
import { tokens } from "styles/Tokens";
import { fileExportHandler } from "utils/CommonFunctions";
import Button from "../Button";
import DateRangePicker from "../DateRangePicker";
import DialogFormation from "../DialogFormation";
import Typography from "../Typography";
import "./index.scss";

interface Props {
  label?: string;
  URL: string;
  data?: any;
  serviceType: string;
  isGet?: boolean;
  isDateRangeApplicable?: boolean;
}

interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
}

const ExportButton = (props: Props) => {
  const { label, isGet = false, isDateRangeApplicable = false } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const translate = useTranslate();
  const [showRangeSelector, setShowRangeSelector] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<DateRange>({ startDate: null, endDate: null });
  const onExportClick = (url?: string) => fileExportHandler(url ?? props.URL, props.serviceType, props.data, isGet);

  const buildExportUrl = () => {
    if (!dateRange.startDate || !dateRange.endDate) return null;
    const formatDate = (date: Date) => date.toLocaleDateString("en-CA");
    const start = formatDate(dateRange.startDate);
    const end = formatDate(dateRange.endDate);
    return `${props.URL}?startDate=${start}&endDate=${end}`;
  };

  return (
    <>
      <div
        className="export-button"
        onClick={() => {
          if (isDateRangeApplicable) setShowRangeSelector(true);
          else onExportClick();
        }}
      >
        <Export />
        <div className="export-label">
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            {label || `Export`}
          </Typography>
        </div>
      </div>
      {showRangeSelector && (
        <DialogFormation
          title={translate("export.header")}
          openDialog={showRangeSelector}
          handleClose={() => setShowRangeSelector(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={() => setShowRangeSelector(false)}
                width={isMobileScreen ? "50%" : "25%"}
              />
              <Button
                disabled={!dateRange?.startDate || !dateRange?.endDate}
                variant="primary"
                label="Download excel"
                onClick={() => {
                  onExportClick(buildExportUrl() ?? props.URL);
                }}
                width={isMobileScreen ? "50%" : "25%"}
              />
            </div>
          }
        >
          <Box
            width="100%"
            alignItems={"flex-start"}
            justifyContent="flex-start"
            textAlign={"center"}
            display={"flex"}
            flexDirection="column"
            gap={"20px"}
            paddingRight={isMobileScreen ? "15px" : "50px"}
            paddingLeft={"15px"}
            marginTop={"10px"}
          >
            <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
          </Box>
        </DialogFormation>
      )}
    </>
  );
};

export default ExportButton;
